import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../../api-client";

const FEATURES_KEY = "features";

enum FeatureName {
  DECOUPLE_VIRTUAL_CARD = "decouple-virtual-card",
  ONLY_VIRTUAL_CARD = "only-virtual-card",
}

interface FeaturesType {
  hasDecoupleVirtualCard: boolean;
  hasOnlyVirtualCard: boolean;
}

const useFeatures = () => {
  const { get } = useApiClient();

  const find = async (): Promise<FeaturesType> => {
    const { data, status } = await get("/v1/employees/features");
    return restoreFeatures(data.content, status);
  };

  const restoreFeatures = (
    features: { name: string }[],
    status: number
  ): FeaturesType => {
    if (status === 204) {
      return {
        hasDecoupleVirtualCard: false,
        hasOnlyVirtualCard: false,
      };
    }

    return {
      hasDecoupleVirtualCard: features.some(
        (feature) => feature.name === FeatureName.DECOUPLE_VIRTUAL_CARD
      ),
      hasOnlyVirtualCard: features.some(
        (feature) => feature.name === FeatureName.ONLY_VIRTUAL_CARD
      ),
    };
  };

  return useQuery({
    queryKey: [FEATURES_KEY],
    queryFn: find,
  });
};

export { useFeatures };
